import { API_HOST } from "../../config/api";
import React, { useEffect, useState, useCallback, useRef } from "react";
import { loadTossPayments } from "@tosspayments/tosspayments-sdk";
import styled from "styled-components";
import RefundPolicyModal from "./RefundPolicyModal";

const clientKey = "live_gck_oEjb0gm23PWAyXKoqO5N8pGwBJn5";
// const clientKey = "test_gck_docs_Ovk5rk1EwkEbP0W43n07xlzm";

const customerKey = "obUjjAlZSKcmUXXn7eUYJ";

const BackgroundWrapper = styled.div`
  background-color: #f0f2f5;
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`;

const ContentWrapper = styled.div`
  max-width: 1128px;
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  color: #000;
  padding: 40px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const Title = styled.h1`
  font-family: Pretendard, sans-serif;
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
`;

const Description = styled.div`
  font-family: Pretendard, sans-serif;
  margin-bottom: 40px;
  padding: 30px;
  background: linear-gradient(135deg, #fff5f5 0%, #ffe5e5 100%);
  border: 2px solid #ff3e61;
  border-radius: 16px;
  color: #333;
  text-align: center;
  box-shadow: 0 4px 12px rgba(255, 62, 97, 0.15);
`;

const DescriptionTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.4;
  color: #000;
`;

const DescriptionContent = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.8;
  color: #555;
`;

const HighlightText = styled.span`
  font-weight: 700;
  color: #ff3e61;
`;

const FeatureList = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  font-weight: 500;
  
  &:before {
    content: "✨";
    font-size: 18px;
  }
`;

const PlansContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
`;

const PlanCard = styled.div`
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  min-height: 200px;

  ${(props) =>
    props.selected &&
    `
    border-color: #ff3e61;
    box-shadow: 0 0 0 2px #ff3e61;
  `}

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
`;

const PlanTitle = styled.h2`
  font-family: Pretendard, sans-serif;
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 15px;
  text-align: center;
`;

const PlanPrice = styled.p`
  font-family: Pretendard, sans-serif;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 5px;
  text-align: center;
`;

const Button = styled.button`
  padding: 10px 15px;
  border-radius: 8px;
  background-color: #ff3e61;
  font-family: Pretendard, sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
  margin-top: 20px;
  &:hover {
    background-color: #ff2545;
  }
  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const SelectedPlanInfo = styled.div`
  margin-top: 20px;
  padding: 20px;
  background-color: #f8f8f8;
  border-radius: 8px;
  font-family: Pretendard, sans-serif;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const RefundButton = styled.button`
  background: none;
  border: none;
  color: #2196f3;
  text-decoration: underline;
  cursor: pointer;
  font-family: Pretendard, sans-serif;
  font-size: 14px;
`;

const DailyPrice = styled.p`
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  font-weight: 500;
  margin-top: 5px;
  text-align: center;
  color: #666;
`;

const OriginalPrice = styled.p`
  font-family: Pretendard, sans-serif;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 5px;
  text-align: center;
  color: #999;
  text-decoration: line-through;
`;

const DiscountBadge = styled.span`
  font-family: Pretendard, sans-serif;
  font-size: 12px;
  font-weight: 600;
  color: #ff3e61;
  margin-left: 8px;
`;

const PaymentSection = styled.div`
  margin-top: 30px;
`;

const BenefitsSection = styled.div`
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
`;

const BenefitsTitle = styled.h3`
  font-family: Pretendard, sans-serif;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #000;
`;

const BenefitsList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  color: #333;
`;

const BenefitItem = styled.li`
  margin-bottom: 8px;
  padding-left: 20px;
  position: relative;

  &:before {
    content: "✓";
    position: absolute;
    left: 0;
    color: #2196f3;
    font-weight: bold;
  }
`;

const KiwoomNotice = styled.div`
  margin-top: 20px;
  padding: 15px;
  background-color: #e3f2fd;
  border-radius: 8px;
  border-left: 4px solid #2196f3;
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  color: #1976d2;
`;

export function CompactPaymentPlansPage() {
  const [selectedPlan, setSelectedPlan] = useState("7d_plan");
  const [amount, setAmount] = useState({
    currency: "KRW",
    value: 5000,
  });
  const [ready, setReady] = useState(false);
  const [widgets, setWidgets] = useState(null);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const isRenderingRef = useRef(false);

  const plans = [
    {
      key: "7d_plan",
      name: "7일 플랜",
      days: 7,
      price: 5000,
    },
    // {
    //   key: "15d_plan",
    //   name: "15일 플랜",
    //   days: 15,
    //   price: 10000,
    // },
    {
      key: "30d_plan",
      name: "30일 플랜",
      days: 30,
      price: 20000,
    },
    {
      key: "365d_plan",
      name: "365일 플랜",
      days: 365,
      price: 200000,
    },
  ];

  useEffect(() => {
    async function fetchPaymentWidgets() {
      const tossPayments = await loadTossPayments(clientKey);
      const widgets = tossPayments.widgets({
        customerKey,
      });
      setWidgets(widgets);
    }
    fetchPaymentWidgets();
  }, []);

  useEffect(() => {
    async function renderPaymentWidgets() {
      if (widgets == null || ready || isRenderingRef.current) {
        return;
      }
      
      isRenderingRef.current = true;
      
      try {
        // 기존 위젯이 있다면 정리
        const paymentMethodEl = document.getElementById("payment-method");
        const agreementEl = document.getElementById("agreement");
        
        if (paymentMethodEl) {
          paymentMethodEl.innerHTML = "";
        }
        if (agreementEl) {
          agreementEl.innerHTML = "";
        }

        await widgets.setAmount(amount);
        await Promise.all([
          widgets.renderPaymentMethods({
            selector: "#payment-method",
            variantKey: "DEFAULT",
          }),
          widgets.renderAgreement({
            selector: "#agreement",
            variantKey: "AGREEMENT",
          }),
        ]);
        setReady(true);
      } catch (error) {
        console.error("위젯 렌더링 오류:", error);
        isRenderingRef.current = false;
      }
    }
    renderPaymentWidgets();
  }, [widgets]);

  useEffect(() => {
    if (widgets == null || !ready) {
      return;
    }
    widgets.setAmount(amount);
  }, [widgets, amount, ready]);

  useEffect(() => {
    const selectedPlanData = plans.find((plan) => plan.key === selectedPlan);
    if (selectedPlanData) {
      setAmount({
        currency: "KRW",
        value: selectedPlanData.price,
      });
    }
  }, [selectedPlan]);

  const handlePlanSelection = (planKey) => {
    setSelectedPlan(planKey);
  };

  const calculateDailyPrice = (plan) => {
    if (plan.price === 0) return null;
    return Math.floor(plan.price / plan.days);
  };

  const calculateOriginalPrice = (plan) => {
    // 7일 플랜 기준: 5,000원
    // 정상가 = 5,000원 × (days / 7)
    if (plan.key === "7d_plan") return null;
    return Math.round(5000 * (plan.days / 7));
  };

  const calculateDiscountRate = (plan) => {
    const originalPrice = calculateOriginalPrice(plan);
    if (!originalPrice) return null;
    const discountRate = Math.round(((originalPrice - plan.price) / originalPrice) * 100);
    return discountRate;
  };

  const handleRefundModalClose = useCallback(() => {
    setIsRefundModalOpen(false);
  }, []);

  return (
    <BackgroundWrapper>
      <ContentWrapper>
        <Title>AlphaNote 구독 플랜</Title>
        <Description>
          <DescriptionTitle>
            번거로움은 이제 그만!<br />
            <HighlightText>키움증권 1계좌만 연결하면 끝</HighlightText>
          </DescriptionTitle>
          <DescriptionContent>
            매일 오후 8시~10시, 당신이 잠든 사이에도<br />
            Daily 매매일지가 자동으로 업로드 + 최신화됩니다.
          </DescriptionContent>
          <FeatureList>
            <FeatureItem>접속할 때마다 최신 분석 리포트 즉시 확인</FeatureItem>
            <FeatureItem>클릭 한 번으로 모든 정보 확인 가능</FeatureItem>
          </FeatureList>
        </Description>


        <PlansContainer>
          {plans.map((plan) => {
            const originalPrice = calculateOriginalPrice(plan);
            const discountRate = calculateDiscountRate(plan);
            return (
              <PlanCard
                key={plan.key}
                selected={selectedPlan === plan.key}
                onClick={() => handlePlanSelection(plan.key)}
              >
                <PlanTitle>{plan.name}</PlanTitle>
                {originalPrice && (
                  <OriginalPrice>₩{originalPrice.toLocaleString()}</OriginalPrice>
                )}
                <PlanPrice>
                  ₩{plan.price.toLocaleString()}
                  {discountRate && (
                    <DiscountBadge>{discountRate}% 할인</DiscountBadge>
                  )}
                </PlanPrice>
                <DailyPrice>
                  {calculateDailyPrice(plan)
                    ? `₩${calculateDailyPrice(plan).toLocaleString()} / 일`
                    : "\u00A0"}
                </DailyPrice>
              </PlanCard>
            );
          })}
        </PlansContainer>

        <SelectedPlanInfo>
          <p>
            최종 가격: ₩
            {plans
              .find((plan) => plan.key === selectedPlan)
              ?.price.toLocaleString()}
            {" "}
            ({plans.find((plan) => plan.key === selectedPlan)?.days}일)
          </p>
          <RefundButton onClick={() => setIsRefundModalOpen(true)}>
            환불 정책 보기
          </RefundButton>
          <RefundPolicyModal
            isOpen={isRefundModalOpen}
            onClose={handleRefundModalClose}
          />
        </SelectedPlanInfo>

        <PaymentSection>
          <div id="payment-method" />
          <div id="agreement" />

          <Button
            disabled={!ready}
            onClick={async () => {
              try {
                const selectedPlanData = plans.find((plan) => plan.key === selectedPlan);
                const amountValue = selectedPlanData.price;
                const days = selectedPlanData.days;
                
                // 백엔드에 주문 생성 요청 (보안을 위해 서버에서 orderId 생성 및 amount, days 저장)
                const orderResponse = await fetch(
                  `${API_HOST}/api/v1b/payments/order`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                    body: JSON.stringify({
                      amount: amountValue,
                      days: days,
                      planName: selectedPlanData.name,
                    }),
                  }
                );
                
                if (!orderResponse.ok) {
                  const errorData = await orderResponse.json();
                  console.error("주문 생성 실패:", errorData);
                  alert("주문 생성에 실패했습니다. 다시 시도해주세요.");
                  return;
                }
                
                const orderData = await orderResponse.json();
                const orderId = orderData.orderId;
                
                // successUrl에는 orderId만 전달 (백엔드에서 orderId로 amount, days 조회)
                await widgets.requestPayment({
                  orderId: orderId,
                  orderName: `${selectedPlanData.name} 구독`,
                  successUrl: `${window.location.origin}/success?orderId=${orderId}`,
                  failUrl: `${window.location.origin}/fail`,
                  customerEmail: localStorage.getItem("email"),
                  customerName: localStorage.getItem("nickname"),
                });
              } catch (error) {
                console.error("결제 요청 오류:", error);
                alert("결제 요청 중 오류가 발생했습니다. 다시 시도해주세요.");
              }
            }}
          >
            결제하기
          </Button>
        </PaymentSection>
      </ContentWrapper>
      <RefundPolicyModal
        isOpen={isRefundModalOpen}
        onClose={handleRefundModalClose}
      />
    </BackgroundWrapper>
  );
}

export default CompactPaymentPlansPage;
